import actions from './constants';

export const fetchDatasetSettings = (category, code) => ({
  category,
  code,
  type: actions.FETCH_DATASET_SETTINGS,
});

export const fetchDatasetSettingsSuccess = (category, code, result) => ({
  category,
  code,
  result,
  type: actions.FETCH_DATASET_SETTINGS_SUCCESS,
});

export const fetchDatasetSettingsError = (category, code, error) => ({
  category,
  code,
  error,
  type: actions.FETCH_DATASET_SETTINGS_ERROR,
});

export const toggleDatasetSetting = (category, code, name, datasetName) => ({
  category,
  code,
  name,
  datasetName,
  type: actions.TOGGLE_DATASET_SETTING,
});

export const updateDatasetSettings = (category, code, properties, datasetName) => ({
  category,
  code,
  datasetName,
  properties,
  type: actions.UPDATE_DATASET_SETTINGS,
});

export const updateDatasetSettingsSuccess = (category, code, result) => ({
  category,
  code,
  result,
  type: actions.UPDATE_DATASET_SETTINGS_SUCCESS,
});

export const updateDatasetSettingsError = (category, code, error, silent) => ({
  category,
  code,
  error,
  silent,
  type: actions.UPDATE_DATASET_SETTINGS_ERROR,
});

export const closeDatasetSettings = ({ category, code }) => ({
  category,
  code,
  type: actions.CLOSE_DATASET_SETTINGS,
});

export const showCatalogueConfirmation = (code, category, template, title) => ({
  category,
  code,
  template,
  title,
  type: actions.SHOW_CATALOGUE_CONFIRMATION,
});

export const ShowDatasetTypeConfirmationWizard = (
  category,
  code,
  template,
  title,
  previousTitle,
  templateChanged,
  datasourceChanged,
) => ({
  category,
  code,
  datasourceChanged,
  template,
  templateChanged,
  title,
  previousTitle,
  type: actions.SHOW_DATASET_TYPE_WIZARD_CONFIRMATION,
});

export const hideDatasetTypeConfirmationWizard = () => ({
  type: actions.HIDE_DATASET_TYPE_WIZARD_CONFIRMATION,
});

export const hideCatalogueConfirmation = () => ({
  type: actions.HIDE_CATALOGUE_CONFIRMATION,
});

export const showWorkflowConfirmation = (code, category, workflow, name) => ({
  category,
  code,
  name,
  type: actions.SHOW_WORKFLOW_CONFIRMATION,
  workflow,
});

export const hideWorkflowConfirmation = () => ({
  type: actions.HIDE_WORKFLOW_CONFIRMATION,
});

export const showEditCohortSettings = (category, code, title) => ({
  type: actions.SHOW_EDIT_COHORT_SETTINGS,
  category,
  code,
  title,
});

export const hideEditCohortSettings = () => ({
  type: actions.HIDE_EDIT_COHORT_SETTINGS,
});

export const updateCohortSettingsProperties = (properties) => ({
  type: actions.UPDATE_COHORT_SETTINGS_PROPERTIES,
  properties,
});

export const switchDatasetType = (
  category,
  code,
  previousTitle,
  template,
  title,
  templateChanged,
  datasourceChanged,
) => ({
  category,
  code,
  datasourceChanged,
  previousTitle,
  template,
  templateChanged,
  title,
  type: actions.SWITCH_DATASET_TYPE,
});
